module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Start / Stop Settings</span></div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-3 prop-sublabel\">Object</div>\r\n    <div class=\"col-md-5 nopadding\" style=\"padding-right: 5px!important;\"><input type=\"text\" value=\"")
    ; __append(escapeFn(selectedObjectName))
    ; __append("\" disabled></input></div>\r\n    <div class=\"col-md-4 nopadding\"><input class=\"btn btn-default hvr-glow\" type=\"button\" id =\"selectObject\" value=\"Select\"></input></div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <span class=\"prop-header prop-label\">Action</span>\r\n    <div class=\"col-md-12\"><input type=\"radio\" name=\"action\" value=\"start\"></input> Start</div>\r\n    <div class=\"col-md-12\"><input type=\"radio\" name=\"action\" value=\"stop\"></input> Stop</div>\r\n    <div class=\"col-md-12\"><input type=\"radio\" name=\"action\" value=\"continue\"></input> Continue</div>\r\n</div>\r\n\r\n\r\n\r\n\r\n")
  }
  return __output;

}